<div class="label-data-details">
  @if (isLoading) {
    <mat-spinner diameter="20"></mat-spinner>
  }

  @if (!isLoading && !labelData && !errorMessage) {
    <div class="no-data">
      No product label data available
    </div>
  }

  @if (!isLoading && errorMessage) {
    <div class="error">
      <mat-icon class="status-red">error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  }

  @if (!isLoading && labelData) {
    <div class="label-json-preview">
      <pre>{{ labelData | json }}</pre>
    </div>
  }
</div>
